import { Component, OnInit, Input, ViewChild, TemplateRef } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { FormBuilder, FormGroup, FormControl, AbstractControl, Validators } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/switchMap';
import { ToasterService } from 'angular2-toaster';
import swal from 'sweetalert2';
import * as _ from 'lodash';
import * as moment from 'moment';

import { Store } from '@ngrx/store';
import * as fromCommonStore from '../../../store';
import * as commonActions from '../../../store/actions/common.actions';

import { CashPaymentModel } from '../../../model/index';
import { CashPaymentService, CommonService, ExpenseTypeService } from '../../../services/index';

@Component({
    selector: 'cash-payment-tab',
    templateUrl: './cashPayment.component.html',
})
export class CashPaymentComponent implements OnInit {
    @Input('tabTitle') title: string;
    @Input() active = false;
    @Input() isCloseable = false;
    //@Input() dataContext;
    _params: any[] = [];
    @Input() set params(val: any[]) {
        this._params = val;

        this.cashPayment['bill_id'] = val['bill_id'];
        this.cashPayment['amount'] = val['amount'];
    }

    minDate: any;
    public mode: string;
    public list: any[] = [];
    public cashPaymentList: any[] = [];
    // readOnly: boolean = false;
    genLedger: any;
    ledgerCtrl: FormControl;
    isLoadMask: Promise<any>;
    cashPayment: CashPaymentModel[];
    isLoading: boolean = false;
    isIncentiveLedger: boolean = false;
    isStaffExpenseLedger: boolean = false;
    branchList: any[] = [];
    expenseTypeList: any[] = [];
    employeeList: any[] = [];
    employeeCtrl: FormControl;
    filteredEmployee: Observable<any[]>;
    private searchTermsEmployee = new Subject<string>();
    billList: any[] = [];
    incentiveDetails: any[] = [];
    incentivePage = { limit: 25, count: 0, offset: 0 };
    private clientSearchTerms = new Subject<string>();
    clientCtrl: FormControl;
    filteredClientList: Observable<any[]>;
    clientList: any[] = [];
    filterData = {
        "search_data": "",
        "from_date": new Date(),
        "to_date": new Date()
    };
    loadingIndicator: boolean = true;

    filteredLedger: Observable<any[]>;
    filteredParty: Observable<any[]>;

    //typeList = []; 
    ledgerList$: any[] = [];
    page = {
        limit: 25,
        count: 0,
        offset: 0,
        orderBy: 'entry_id',
        orderDir: 'desc'
    };
    @ViewChild('snoTemplate') snoTemplate: TemplateRef<any>;
    @ViewChild('editDeleteTemplate') editDeleteTemplate: TemplateRef<any>;
    @ViewChild('filterPanel') filterPanel;

    columns = [];
    scrollTimeout: any;
    suppressPaging: boolean = false;

    constructor(private cashPaymentService: CashPaymentService,
        public toasterService: ToasterService, private commonService: CommonService,
        private expenseTypeService: ExpenseTypeService,
        public store: Store<any>)
    {
        //FOR AUTO COMPLETE VALIDATION --- BRAND MODEL
        function hasValidLedger(input: FormControl) {
            let ledgerID = input.value, retVal = null;
            if (ledgerID == "") {
                retVal = { inValidLedger: true };
            }
            if (ledgerID && typeof ledgerID === 'string') {
                retVal = { inValidLedger: true };
            }
            return retVal;
        }
        this.ledgerCtrl = new FormControl('', [
            Validators.required,
            hasValidLedger.bind(this)
        ]);
        this.filteredLedger = this.ledgerCtrl.valueChanges
            .startWith(null)
            .map(val => {
                if (val && typeof val === 'number') {
                    let item = _.find(this.ledgerList$, { 'genLedid': val });
                    if (item) {
                        this.isStaffExpenseLedger = item.name.toUpperCase().indexOf('FOR STAFF EXPENSES') !== -1;
                        this.isIncentiveLedger = item.name.toUpperCase().indexOf('INCENTIVE') !== -1;
                    }
                } else if (!val || typeof val === 'string') {
                    this.isStaffExpenseLedger = false;
                }
                return val ? this.filterLedger(val) : this.ledgerList$.slice();
            });
    
        this.clientCtrl = new FormControl('');

        this.employeeCtrl = new FormControl('');
        this.filteredEmployee = this.searchTermsEmployee
            .debounceTime(300)
            .distinctUntilChanged()
            .switchMap(term => term
                ? this.commonService.getEmployeeList(term, 'challan')
                : Observable.of<any[]>([])
            );
        this.filteredEmployee.subscribe(($e) => {
            this.employeeList = $e;
        });

        this.cashPayment = [];
        this.cashPayment['mode'] = 'Add';
    }

    ngOnInit(): void {
       
        this.columns = [
            { name: 'SNo', prop: 'sno', width: 50, minWidth: 50, maxWidth: 50, sortable: false, cellClass: 'cell-center', cellTemplate: this.snoTemplate, toggle: true },
            { name: 'Ledger Name', prop: 'name', width: 220, minWidth: 220, maxWidth: 220, toggle: true },
            { name: 'Amount', prop: 'amount', width: 100, minWidth: 100, maxWidth: 100, toggle: true },
            { name: 'Remarks', prop: 'narration', width: 220, minWidth: 220, maxWidth: 220 },
            { name: 'Action', prop: 'action', width: 95, minWidth: 95, maxWidth: 95, sortable: false, cellClass: 'cell-left', cellTemplate: this.editDeleteTemplate }
        ];
        let that = this;
        this.filteredClientList = this.clientSearchTerms
            .debounceTime(300)
            .distinctUntilChanged()
            .switchMap(term => term
                ? this.commonService.loadClientList(term, 'salesBillentry')
                : Observable.of<any[]>([])
            );
        this.filteredClientList.subscribe(($e) => {
            that.clientList = $e;
        });

        this.pageCallback({ offset: 0 });
        this.loadLedgerCity();
        this.loadBranchList();
        this.loadExpenseTypes();

        this.minDate = new Date(new Date().getFullYear(),
        new Date().getMonth(),
        new Date().getDate());
        this.cashPayment['voucher_date'] = new Date();
    }

    loadLedgerCity() {
        let that = this,
        params = { 
        client_id: this._params['client_id'],
        }
        this.commonService
            .getLedgerList(params)
            .then(function(res: any) {
                if (res.success) {
                    that.ledgerList$ = res.data;
                    that.ledgerCtrl.setValue(that.cashPayment['name']);

                    if(that._params['from_page'] == 'Sales Return') {
                        that.cashPayment['genLedid'] = res.data[0].genLedid;
                    }

                    // for(let i = 0; i< res.data.length; i++) {
                    //     that.cashPayment['hidden_genLedid'] = res.data[i].name;
                    // }
                    // that.ledgerCtrl.setValue(that.cashPayment['genLedid']);
                    // that.cashPayment['voucher_date'] = new Date(that._params['date']);
                    // that.cashPayment['amount'] = that._params['amount'];
                    // that.readOnly = true;
                    // that.ledgerCtrl.disable();
                }
            });
    }

    loadBranchList() {
        let that = this;
        this.store.select(fromCommonStore.getAllBranch).subscribe((res: any) => {
            if (res && res.data && res.data.length > 0) {
                that.branchList = _.filter(res.data, function(obj) { return obj['is_crm_branch'] == 'Yes'; });
            } else {
                that.store.dispatch(new commonActions.LoadAllBrand());
            }
        });
    }

    loadExpenseTypes() {
        let that = this;
        this.expenseTypeService.getExpenseTypeList({
            start: '0', limit: '100', orderColumn: 'name', orderDir: 'asc',
            filter: JSON.stringify({ search_data: '' })
        }).then(function(res: any) {
            if (res && res.data) {
                that.expenseTypeList = _.filter(res.data, function(o: any) { return o.status === 'Active'; });
            }
        });
    }

    filterLedger(name: string) {
        name = _.escapeRegExp(name);
        return this.ledgerList$.filter(item => (new RegExp(name, 'gi').test(item.name)));
    }

    displayFn(genLedid: any) {
        if (this.ledgerList$ != undefined) {
            if (genLedid && this.ledgerList$.length > 0) {
                let item = _.find(this.ledgerList$, { 'genLedid': genLedid });
                if(item !== undefined) {
                    this.cashPayment['genLedid'] = item.genLedid;
                    this.cashPayment['name'] = item.name;
                    this.isIncentiveLedger = item.name.toUpperCase().indexOf('INCENTIVE') !== -1;
                    this.isStaffExpenseLedger = item.name.toUpperCase().indexOf('FOR STAFF EXPENSES') !== -1;
                    if (!this.isIncentiveLedger) {
                        this.cashPayment['client_id']   = '';
                        this.cashPayment['client_no']   = '';
                        this.cashPayment['client_name'] = '';
                        this.cashPayment['bill_no']     = '';
                        this.cashPayment['bill_date']   = '';
                        this.clientCtrl.setValue('');
                    }
                    if (!this.isStaffExpenseLedger) {
                        this.cashPayment['emp_id']         = '';
                        this.cashPayment['emp_name']       = '';
                        this.cashPayment['exp_allowances'] = '';
                        this.cashPayment['from_branch_id'] = '';
                        this.cashPayment['to_branch_id']   = '';
                        this.cashPayment['expense_type_id'] = '';
                        this.employeeCtrl.setValue('');
                    }
                    return item['name'];
                }
            }
        }
        return '';
    }

    onEnterKeyPressed(nextEl: string): void {
        $('#' + nextEl).focus();
    }
    /**
    * Called whenever the user changes page
    */
    pageCallback(pageInfo: { count?: number, pageSize?: number, limit?: number, offset?: number }) {
        if (!this.suppressPaging) {
            this.page.offset = pageInfo.offset;
            this.getCashPaymentList();
        }
    }

    /**
   * Called whenever the user changes the sort order
   */
    sortCallback(sortInfo: { sorts: { dir: string, prop: string }[], column: {}, prevValue: string, newValue: string }) {
        // there will always be one "sort" object if "sortType" is set to "single"
        this.page.orderDir = sortInfo.sorts[0].dir;
        this.page.orderBy = sortInfo.sorts[0].prop;
        this.getCashPaymentList();
    }
    onScroll() {
        this.suppressPaging = true;

        if (this.scrollTimeout) {
            //celarTimeout(this.scrollTimeout);
        }

        this.scrollTimeout = setTimeout(() => {
            this.suppressPaging = false;
        }, 100)
    }

    onOpenedFilter(): void {
        setTimeout(function() {
            $('#filterSearch').focus();
        }, 100);

    }

    onChangePageSize(limit) {
        this.page.limit = limit;
        this.getCashPaymentList();
    }

    clearFilter(): void {
        this.filterData = {
            "search_data": "",
            "from_date": new Date(),
            "to_date": new Date()
        };
        this.applyFilter();
    }

    applyFilter(): void {
        //this.filterExpand = false;
        this.filterPanel.close();
        this.getCashPaymentList();
    }

    getCashPaymentList(): void {
        if(this._params['from_page'] != 'Sales Return') {
        let params = {
            start: `${this.page.offset}`,
            limit: `${this.page.limit}`,
            orderColumn: `${this.page.orderBy}`,
            orderDir: `${this.page.orderDir}`,
            search_data: this.filterData['search_data'],
            from_date: moment(this.filterData['from_date']).format('YYYY-MM-DD'),
            to_date: moment(this.filterData['to_date']).format('YYYY-MM-DD'),
            // from_page: this['params']['tabParams']
            from_page: this['_params']['tabParams']
        };
        let that = this;
        this.isLoadMask = this.cashPaymentService
            .getCashPaymentList(params)
            .then(function(res: any) {
                that.loadingIndicator = false;
                that.page.count = res.totCnt;
                that.cashPaymentList = res.data;
            });
        }
    }

    public onEditCash(row: any): void {
        row['mode'] = 'Edit';
        row['voucher_date'] = new Date(row['voucher_date']);
        this.cashPayment = [];
        this.cashPayment = Object.assign({}, row);
        this.isIncentiveLedger = row['name'] && row['name'].toUpperCase().indexOf('INCENTIVE') !== -1;
        this.isStaffExpenseLedger = row['name'] && row['name'].toUpperCase().indexOf('FOR STAFF EXPENSES') !== -1;
        if (this.isStaffExpenseLedger) {
            if (row['emp_name']) {
                const fakeEmp = { empid: row['emp_name'], userid: row['emp_name'], empname: row['emp_name'], fullname: row['emp_name'] };
                this.employeeList = [fakeEmp];
                this.employeeCtrl.setValue(row['emp_name']);
            } else {
                this.employeeCtrl.setValue('');
            }
        } else {
            this.employeeCtrl.setValue('');
        }
        // Clear incentive form fields — they are for adding new rows only
        this.cashPayment['client_id']   = '';
        this.cashPayment['client_no']   = '';
        this.cashPayment['client_name'] = '';
        this.cashPayment['bill_date']   = null;
        this.cashPayment['bill_no']     = '';
        this.clientCtrl.setValue('');
        this.billList = [];
        this.incentiveDetails = [];
        if (this.isIncentiveLedger) {
            // Load from stored JSON (new records)
            if (row['incentive_details']) {
                try {
                    let details = typeof row['incentive_details'] === 'string'
                        ? JSON.parse(row['incentive_details'])
                        : row['incentive_details'];
                    this.incentiveDetails = details || [];
                } catch (e) { }
            }
            // Legacy fallback: single client/bill stored in root columns
            if (this.incentiveDetails.length === 0 && row['client_id'] && row['bill_no']) {
                let billDateFmt  = row['bill_date'] ? moment(row['bill_date']).format('YYYY-MM-DD')  : '';
                let billDateDisp = row['bill_date'] ? moment(row['bill_date']).format('DD-MM-YYYY') : '';
                this.incentiveDetails = [{
                    client_id:      row['client_id'],
                    client_no:      row['client_no'],
                    client_name:    row['client_name'],
                    bill_date:      billDateFmt,
                    bill_date_disp: billDateDisp,
                    bill_no:        row['bill_no'],
                    bill_amount:    ''
                }];
            }
            this.incentivePage.count = this.incentiveDetails.length;
        }
    }

    searchClient(query: string): void {
        this.clientSearchTerms.next(query);
    }

    displayClientFn(client_id: any) {
        if (this.clientList != undefined) {
            if (client_id && this.clientList.length > 0) {
                let fitem = _.find(this.clientList, { 'client_id': client_id });
                if (fitem) {
                    this.cashPayment['client_id']   = fitem.client_id;
                    this.cashPayment['client_name'] = fitem.client_name;
                    this.cashPayment['client_no']   = fitem.client_no;
                    return fitem['client_no'];
                }
            }
        }
        return '';
    }

    onBillDateChange(): void {
        let client_id = this.cashPayment['client_id'];
        let bill_date  = this.cashPayment['bill_date'];
        if (!client_id || !bill_date) return;
        let that = this;
        let billDateFmt = moment(bill_date).format('YYYY-MM-DD');
        this.cashPayment['bill_no'] = '';
        this.billList = [];
        this.cashPaymentService.getBillsByClientDate({ client_id: client_id, bill_date: billDateFmt })
            .then(function(res: any) {
                if (res.success) {
                    that.billList = res.data;
                }
            });
    }

    addIncentiveDetail(): void {
        if (_.isEmpty(_.toString(this.cashPayment['client_id']))) {
            swal('WARNING', 'Please Select Client ID');
            return;
        }
        if (_.isEmpty(_.toString(this.cashPayment['client_name']))) {
            swal('WARNING', 'Please Enter Client Name');
            return;
        }
        if (_.isEmpty(_.toString(this.cashPayment['bill_date']))) {
            swal('WARNING', 'Please Select Bill Date');
            return;
        }
        if (_.isEmpty(_.toString(this.cashPayment['bill_no']))) {
            swal('WARNING', 'Please Select Bill No');
            return;
        }
        let exists = _.find(this.incentiveDetails, {
            client_id: this.cashPayment['client_id'],
            bill_no:   this.cashPayment['bill_no']
        });
        if (exists) {
            swal('WARNING', 'Bill No: ' + this.cashPayment['bill_no'] + ' is already added');
            return;
        }
        let billDateFmt  = moment(this.cashPayment['bill_date']).format('YYYY-MM-DD');
        let billDateDisp = moment(this.cashPayment['bill_date']).format('DD-MM-YYYY');
        let selectedBill = _.find(this.billList, { 'bill_no': this.cashPayment['bill_no'] });
        let row = {
            client_id:      this.cashPayment['client_id'],
            client_no:      this.cashPayment['client_no'],
            client_name:    this.cashPayment['client_name'],
            bill_date:      billDateFmt,
            bill_date_disp: billDateDisp,
            bill_no:        this.cashPayment['bill_no'],
            bill_amount:    selectedBill ? selectedBill.amount : ''
        };
        this.incentiveDetails = [...this.incentiveDetails, Object.assign({}, row)];
        this.incentivePage.count = this.incentiveDetails.length;
        // Reset incentive form fields
        this.cashPayment['client_id']   = '';
        this.cashPayment['client_no']   = '';
        this.cashPayment['client_name'] = '';
        this.cashPayment['bill_date']   = null;
        this.cashPayment['bill_no']     = '';
        this.clientCtrl.setValue('');
        this.billList = [];
    }

    onDeleteIncentiveRow(row: any): void {
        let that = this;
        swal({
            title: 'Are you sure to Delete?',
            text: 'You will not be able to Recover: Bill No ' + row.bill_no + ' (' + row.client_name + ')',
            showCancelButton: true,
            confirmButtonText: 'Yes, Delete!',
            cancelButtonText: 'No, Cancel...'
        }).then(function() {
            that.incentiveDetails = that.incentiveDetails.filter(r => r !== row);
            that.incentivePage.count = that.incentiveDetails.length;
        }, function(dismiss) { });
    }

    get totalBillAmount(): number {
        return this.incentiveDetails.reduce((sum, row) => sum + (_.toNumber(row.bill_amount) || 0), 0);
    }

    searchEmployee(query: string): void {
        this.searchTermsEmployee.next(query);
    }

    displayEmployeeFn(empID: any): string {
        if (empID && this.employeeList && this.employeeList.length > 0) {
            let empObj = _.find(this.employeeList, { 'empid': empID })
                      || _.find(this.employeeList, { 'userid': empID });
            if (empObj) {
                this.cashPayment['emp_id']   = empID;
                this.cashPayment['emp_name'] = empObj['empname'] || empObj['fullname'];
                return empObj['empname'] || empObj['fullname'];
            }
        }
        if (empID && typeof empID === 'string') {
            return empID;
        }
        return '';
    }

    onReset(): void {
        let voucher_date = this.cashPayment['voucher_date'];
        this.cashPayment = [];
        this.cashPayment['voucher_date'] = voucher_date;
        this.cashPayment['mode'] = 'Add';
        this.isIncentiveLedger = false;
        this.isStaffExpenseLedger = false;
        this.billList = [];
        this.incentiveDetails = [];
        this.incentivePage.count = 0;
        this.ledgerCtrl.setValue('');
        this.clientCtrl.setValue('');
        this.employeeCtrl.setValue('');
    }
    
    onSaveCashPayment(): void {
        let Bill_id = '';
        let that = this,
            mode = this.cashPayment['mode'];

        if (_.isEmpty(_.toString(this.cashPayment['genLedid']))) {
            swal('WARNING', 'Please Select Ledger List');
            return;
        }
        if (_.isEmpty(this.cashPayment['narration'])) {
            swal('WARNING', 'Please Enter Narration');
            return;
        }
        if (this.isIncentiveLedger) {
            if (this.incentiveDetails.length === 0) {
                swal('WARNING', 'Please add at least one Bill detail in the table');
                return;
            }
        }
        if (this.isStaffExpenseLedger) {
            if (!this.cashPayment['emp_id']) {
                swal('WARNING', 'Please Select Employee Name');
                return;
            }
            if (!this.cashPayment['from_branch_id']) {
                swal('WARNING', 'Please Select From Branch');
                return;
            }
            if (!this.cashPayment['to_branch_id']) {
                swal('WARNING', 'Please Select To Branch');
                return;
            }
            if (!this.cashPayment['expense_type_id']) {
                swal('WARNING', 'Please Select Expense Type');
                return;
            }
            if (!this.cashPayment['exp_allowances']) {
                swal('WARNING', 'Please Select Expenses or Allowances');
                return;
            }
        }
        let ledgerDate = moment(this.cashPayment['voucher_date']).format('YYYY-MM-DD'),
            data = {
                mode: this.cashPayment['mode'],
                entry_id: this.cashPayment['entry_id'],
                bill_id: this.cashPayment['bill_id'],
                voucher_date: ledgerDate,
                genLedid: this.cashPayment['genLedid'],
                name: this.cashPayment['name'],
                amount: this.cashPayment['amount'],
                narration: this.cashPayment['narration'],
                incentive_details: this.isIncentiveLedger ? JSON.stringify(this.incentiveDetails) : '',
                emp_name: this.isStaffExpenseLedger ? (this.cashPayment['emp_name'] || '') : '',
                exp_allowances: this.isStaffExpenseLedger ? (this.cashPayment['exp_allowances'] || '') : '',
                from_branch_id: this.isStaffExpenseLedger ? (this.cashPayment['from_branch_id'] || '') : '',
                to_branch_id: this.isStaffExpenseLedger ? (this.cashPayment['to_branch_id'] || '') : '',
                expense_type_id: this.isStaffExpenseLedger ? (this.cashPayment['expense_type_id'] || '') : ''
            };
        this.isLoading = true;
        this.cashPaymentService
            .addCashPaymentDetails(data)
            .then(function(res: any) {
                that.isLoading = false;
                if (res.success) {
                    swal('SUCCESS', res.message, 'success');
                    that.onReset();
                    that.getCashPaymentList();
                } else {
                    var toast = {
                        type: 'error',
                        title: 'ERROR',
                        body: res.message
                    };
                    that.toasterService.pop(toast);
                }
            });
    }
    onDeleteCash(row: any): void {
        let that = this,
            data = {
                entry_id: row.entry_id
            };
        swal({
            title: 'Are you sure to Delete?',
            text: 'You will not be able to Recover: ' + row.name + ' Again!',
            showCancelButton: true,
            confirmButtonText: 'Yes, Delete!',
            cancelButtonText: 'No, Keep it'
        }).then(function() {
            that.isLoadMask = that.cashPaymentService
                .deleteCashPayment(data)
                .then(function(res: any) {
                    if (res.success) {
                        that.getCashPaymentList();
                        swal(
                            'Deleted',
                            res.message,
                            'success'
                        );
                    } else {
                        swal(
                            'ERROR',
                            res.message,
                            'error'
                        );
                    }

                });
        }, function(dismiss) {

        });
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/transaction/cashPayment/cashPayment.component.ts